import { View } from 'react-native';
import styled from 'styled-components/native';
const CheckBoxContainer = styled(View) `
  align-items: center;
  flex-direction: row;
  ${props => props.customStyle}
`;
export default CheckBoxContainer;
